import { createFileRoute, redirect } from '@tanstack/react-router'
import {
  GlobalSearchParams,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { SEARCH_PARAM_COMPONENT_ID } from 'routes/virtual-reports/-searchParams'
import { Route as NewRoute } from 'routes/virtual-reports/details'

export const Route = createFileRoute(
  '/virtual-reports/(deprecated_routes)/$siteID/$componentID'
)({
  beforeLoad: ({ params }) => {
    const { siteID: siteId, componentID: componentId } = params

    throw redirect({
      to: NewRoute.to,
      search: (prev: Record<string, unknown> & GlobalSearchParams) => ({
        ...prev,
        [SEARCH_PARAM_SITE_ID]: siteId,
        [SEARCH_PARAM_COMPONENT_ID]: componentId,
      }),
      replace: true,
    })
  },
})
